import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import {
  createcalibrationApi,
  getInstrument,
} from "../../../services/CalibrationService";
import { StaticSelectInput } from "../../constant/SelectInput";
import { Modal } from "react-bootstrap";

const AddCalibration = ({ handleAfterCreate }) => {
  const [dataInput, setDataInput] = useState({
    calibration_name: "",
    description: "",
    schedule_at: "",
    instrument_ids: [],
  });
  const [errors, setErrors] = useState({});
  const [instrument, setInstrument] = useState([]);
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const fetchInstrument = async () => {
      try {
        const resp = await getInstrument();
        setInstrument(resp.data.data);
      } catch (error) {
        console.error("Error fetching divisions:", error);
      }
    };

    fetchInstrument();
  }, []);

  const openModal = () => setShowModal(true);

  const closeModal = () => {
    setDataInput({
      calibration_name: "",
      description: "",
      schedule_at: "",
      instrument_ids: [],
    });
    setErrors({});
    setShowModal(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
    setDataInput((prevDataInput) => ({ ...prevDataInput, [name]: value }));
  };

  const handleSelectChange = (name, value) => {
    setDataInput((prev) => ({ ...prev, [name]: value }));
  };

  const validateInputs = () => {
    const newErrors = {};
    if (!dataInput.calibration_name)
      newErrors.calibration_name = "Title is required.";
    if (!dataInput.schedule_at)
      newErrors.schedule_at = "Schedule At is required.";
    if (!dataInput.description)
      newErrors.description = "Description is required.";
    if (!dataInput.instrument_ids.length)
      newErrors.instrument_ids = "At least one instrument must be selected.";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!validateInputs()) return;

    try {
      setIsSubmitLoading(true);
      const date = new Date(dataInput.schedule_at);
      const formattedScheduleAt = `${date.getFullYear()}-${(date.getMonth() + 1)
        .toString()
        .padStart(2, "0")}-${date.getDate().toString().padStart(2, "0")} ${date
        .getHours()
        .toString()
        .padStart(2, "0")}:${date
        .getMinutes()
        .toString()
        .padStart(2, "0")}:${date.getSeconds().toString().padStart(2, "0")}`;

      const payload = {
        ...dataInput,
        schedule_at: formattedScheduleAt,
      };

      const response = await createcalibrationApi(payload);
      handleAfterCreate(response.data.results);
      toast.success(response.data.message);
      closeModal();
    } catch (error) {
      toast.error(error.response?.data?.message);
    } finally {
      setIsSubmitLoading(false);
    }
  };

  return (
    <>
      <button className="btn btn-primary mx-2" onClick={openModal}>
        Add Calibration
      </button>
      <Modal show={showModal} onHide={closeModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>Add Calibration</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row mb-2">
            <div className="col-md-6">
              <div className="form-group mb-3">
                <label className="form-label">
                  Title<span className="text-danger">*</span>
                </label>
                <input
                  className="form-control"
                  placeholder="Enter Title"
                  name="calibration_name"
                  value={dataInput.calibration_name}
                  onChange={handleChange}
                />
                {errors.calibration_name && (
                  <div className="text-danger">{errors.calibration_name}</div>
                )}
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group mb-3">
                <label className="form-label">
                  Schedule At<span className="text-danger">*</span>
                </label>
                <input
                  type="datetime-local"
                  className="form-control"
                  name="schedule_at"
                  value={dataInput.schedule_at}
                  onChange={handleChange}
                />
                {errors.schedule_at && (
                  <div className="text-danger">{errors.schedule_at}</div>
                )}
              </div>
            </div>
            <div className="col-md-12">
              <div className="form-group mb-3">
                <StaticSelectInput
                  setParentInputValue={handleSelectChange}
                  optionsList={instrument.map((item) => ({
                    value: item.id,
                    label: item.name,
                  }))}
                  name="instrument_ids"
                  id="instrument_ids"
                  isClearable
                  placeholder="Select Instrument"
                  label="Instrument"
                  is_multi={true}
                  isRequired={true}
                />
                {errors.instrument_ids && (
                  <div className="text-danger">{errors.instrument_ids}</div>
                )}
              </div>
            </div>
            <div className="col-md-12">
              <div className="form-group mb-3">
                <label className="form-label">
                  Description<span className="text-danger">*</span>
                </label>
                <textarea
                  className="form-control"
                  name="description"
                  placeholder="Enter Description"
                  value={dataInput.description}
                  onChange={handleChange}
                ></textarea>
                {errors.description && (
                  <div className="text-danger">{errors.description}</div>
                )}
              </div>
            </div>
          </div>
          <div className="d-flex align-items-center justify-content-start">
            <button
              type="button"
              className="btn btn-primary me-3"
              onClick={handleSubmit}
              disabled={isSubmitLoading}
            >
              {isSubmitLoading ? "Submitting..." : "Submit"}
            </button>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={closeModal}
            >
              Cancel
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default AddCalibration;
